import { ChevronLeft, Share2, Trash2 } from "lucide-react"
import { useState } from "react"
import { useDeleteThreadMutation } from "../../../../redux/queries/conversations"
import { toggleCurrentThreadDetailsView } from "../../../../redux/slices/conversations"
import { Thread } from "../../../../types"
import { useAppDispatch } from "../../../hooks"
import { LinkBtn } from "../../buttons"
import InitialsAvatar from "../../initials-avatar"
import { Link } from "react-router-dom"
import ExportConversationModal from "../../export-conversation-modal"

interface Props {
  thread: Thread
}

const Header = ({ thread }: Props) => {
  const dispatch = useAppDispatch()
  const [showExportModal, setShowExportModal] = useState(false)

  const initials = `${thread.first_name[0]}${thread.last_name[0]}`

  const toggleDetailsView = () => {
    dispatch(toggleCurrentThreadDetailsView())
  }

  const [deleteThread, { isLoading: isDeletingThread }] =
    useDeleteThreadMutation()

  const handleDeleteThread = () => {
    const shouldDeleteThread = window.confirm(
      "Are you sure you want to delete this thread?"
    )
    if (shouldDeleteThread) deleteThread({ threadId: thread._id })
  }

  const openShareModal = () => {
    setShowExportModal(true)
  }

  const closeExportModal = () => {
    setShowExportModal(false)
  }

  return (
    <div className="sticky top-0 pl-1 pr-2 sm:px-6 py-3 bg-white">
      <div className="flex items-center">
        <Link
          to="/conversations"
          className="rounded-lg sm:hidden px-1 py-1 h-8 inline-flex items-center mr-1"
        >
          <ChevronLeft size={24} aria-hidden="true" />
          <span className="sr-only">Back</span>
        </Link>
        <h3 className="flex items-center">
          <InitialsAvatar initials={initials} />
          <span className="ml-2">
            {thread.first_name} {thread.last_name}
          </span>
        </h3>

        <LinkBtn
          onClick={toggleDetailsView}
          text="base"
          className="ml-auto hover:no-underline !px-2"
          disabled={isDeletingThread}
        >
          Lead Details
        </LinkBtn>

        <LinkBtn
          onClick={openShareModal}
          text="base"
          className="ml-1 md:ml-2 hover:no-underline !px-2 flex items-center"
        >
          <Share2 size={16} aria-hidden="true" className="md:mr-2" />
          <span className="hidden md:inline">Share</span>
        </LinkBtn>

        <LinkBtn
          onClick={handleDeleteThread}
          className="ml-1 md:ml-2 hover:no-underline !px-2"
          disabled={isDeletingThread}
        >
          <Trash2 size={16} aria-hidden="true" />
          <span className="sr-only">Delete conversation</span>
        </LinkBtn>
      </div>

      <ExportConversationModal
        show={showExportModal}
        thread={thread}
        onClose={closeExportModal}
      />
    </div>
  )
}

export default Header
